export const priceSimpleFilter = (searchResults, priceSelected) => {
  return searchResults.filter(
    clusterObj => clusterObj.cluster.composition_price.total <= priceSelected
  );
};
